import React, { Component } from 'react'
import { connect } from 'react-redux'

class ImmunizationsSideInfo extends Component {
    render() {
        return (
            <div className="w-100">
                <div className="side-alert">
                    <p>
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1_1}<b>{this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1_2}</b>{this.props.strings.IMMUNIZATIONS_SIDE_ALERT_1_3}
                    </p>
                    <p>
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_2}
                    </p>
                    <p>
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_3}
                        <a href={this.props.strings.IMMUNIZATIONS_SIDE_ALERT_3_LINK} target="_blank">
                            <i>{this.props.strings.IMMUNIZATIONS_SIDE_ALERT_3_LINK_TEXT}</i>
                        </a>
                        {this.props.strings.IMMUNIZATIONS_SIDE_ALERT_3_2}
                    </p>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        showPrint: ownProps.showPrint
    }
}

const ConnectedImmunizationsSideInfo = connect(
    mapStateToProps
)(ImmunizationsSideInfo);
export default ConnectedImmunizationsSideInfo;